// eslint-disable-next-line import/prefer-default-export
export function formatedDuration(timeInSeconds: number): string {
    let signConst = '';
    if (timeInSeconds >= 0) {
        signConst = '';
    } else {
        signConst = '-';
    }
    const hr = Math.floor(Math.abs(timeInSeconds) / 3600);
    const min = Math.floor((Math.abs(timeInSeconds) % 3600) / 60);
    const sec = Math.abs(timeInSeconds) % 60;
    let secMin = '';
    if (hr > 0) {
        secMin += `${hr}:${min < 10 ? '0' : ''}`;
    }
    secMin += `${min}:${sec < 10 ? '0' : ''}`;
    secMin += `${sec}`;
    if (hr > 0) {
        return `${signConst}${secMin} Hr`;
    }
    if (min > 0) {
        return `${signConst}${secMin} Min`;
    }
    if (sec > 0) {
        return `${signConst}${sec} Sec`;
    }
    return '';
}
